export const ALLOWED_FORMATS = {
  video: [
    "video/mp4", // .mp4
    "video/webm", // .webm
    "video/ogg", // .ogv
    "video/quicktime", // .mov
    "video/x-matroska", // .mkv
    "video/x-msvideo" // .avi
  ],
  audio: [
    "audio/mpeg", // .mp3
    "audio/wav", // .wav
    "audio/wave", // .wav альтернативный MIME
    "audio/x-wav", // .wav альтернативный MIME
    "audio/ogg", // .ogg, .oga
    "audio/webm", // .webm (audio)
    "audio/mp4", // .m4a
    "audio/x-m4a", // .m4a альтернативный MIME
    "audio/flac", // .flac
    "audio/x-flac", // .flac альтернативный MIME
    "audio/aac", // .aac
    "audio/opus", // .opus
    "audio/amr", // .amr
    "audio/aiff", // .aiff, .aif
    "audio/x-aiff", // .aiff, .aif альтернативный MIME
    "audio/x-ms-wma" // .wma
  ]
};

export const ALLOWED_EXTENSIONS = [
  ".mp4",
  ".webm",
  ".ogv",
  ".mov",
  ".mkv",
  ".avi",
  ".mp3",
  ".wav",
  ".ogg",
  ".oga",
  ".m4a",
  ".flac",
  ".aac",
  ".opus",
  ".amr",
  ".aiff",
  ".aif",
  ".wma"
];

export const ALLOWED_FORMATS_TEXT = "MP4, WebM, OGG, MOV, MKV, AVI, MP3, WAV, M4A, FLAC, AAC, Opus, AMR, AIFF, WMA";

// Максимальный размер файла: 2GB (соответствует бэкенду)
export const MAX_FILE_SIZE = 2 * 1024 * 1024 * 1024; // 2GB в байтах
export const MAX_FILE_SIZE_TEXT = "2 ГБ";

export const getAllAllowedFormats = (): string[] => {
  return [...ALLOWED_FORMATS.video, ...ALLOWED_FORMATS.audio];
};

export const isFormatAllowed = (mimeType: string, fileName?: string): boolean => {
  // Проверяем MIME-тип
  if (getAllAllowedFormats().includes(mimeType)) {
    return true;
  }

  // Если MIME-тип не подходит, проверяем расширение файла
  if (fileName) {
    const extension = fileName.toLowerCase().match(/\.[^.]+$/)?.[0];
    if (extension && ALLOWED_EXTENSIONS.includes(extension)) {
      return true;
    }
  }

  return false;
};
